// ── SPLASH (homepage intro animation) ──
(function () {
  var splash = document.getElementById('moqu-splash');
  if (!splash) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    splash.classList.add('is-done');
    return;
  }

  // SessionStorage-Check entfernt → Splash bei jedem Reload zeigen

  document.body.classList.add('splash-active');

  setTimeout(function () {
    splash.classList.add('is-leaving');
    setTimeout(function () {
      splash.classList.add('is-done');
      document.body.classList.remove('splash-active');
    }, 900);
  }, 2800);   // 5s statt 3.5s

  // bfcache: if page is restored from back/forward, ensure splash is gone
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      splash.classList.add('is-done');
      document.body.classList.remove('splash-active');
    }
  });
})();
// ── PARALLAX FLOATING (about-chapters images) ──
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var images = [];
  var ticking = false;

  function collect() {
    images = Array.from(document.querySelectorAll('.chap-img-main, .chap-img-overlay'));
  }
  function clearAll() {
    images.forEach(function (el) { el.style.transform = ''; });
  }
  function update() {
    if (window.innerWidth < 760) {
      clearAll();
      return;
    }
    var vh = window.innerHeight;
    images.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -50 || rect.top > vh + 50) return;
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / vh;
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;
      var speed = el.classList.contains('chap-img-overlay') ? -38 : -16;
      el.style.transform = 'translate3d(0,' + (progress * speed).toFixed(2) + 'px,0)';
    });
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }
  function init() {
    collect();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ── SCROLL REVEAL ──
var revealObserver = (function () {
  if (!('IntersectionObserver' in window)) {
    Array.from(document.querySelectorAll('.reveal')).forEach(function(el) { el.classList.add('visible'); });
    return function() {};
  }
  var _pending   = [];
  var _revealed  = false;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      observer.unobserve(e.target);
      if (_revealed) {
        e.target.classList.add('visible');
      } else {
        _pending.push(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

  function flushPending() {
    _revealed = true;
    _pending.sort(function (a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });
    _pending.forEach(function (el, i) {
      setTimeout(function () { el.classList.add('visible'); }, i * 55);
    });
    _pending = [];
  }

  function observe(els) {
    var vp = window.innerHeight;
    els.forEach(function (el) {
      if (el.classList.contains('visible')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < vp && rect.bottom > 0) {
        if (_revealed) {
          el.classList.add('visible');
        } else {
          _pending.push(el);
        }
      } else {
        observer.observe(el);
      }
    });
  }

  observe(Array.from(document.querySelectorAll('.reveal')));

  var _html = document.documentElement;
  if (!_html.classList.contains('cms-loading')) {
    requestAnimationFrame(flushPending);
  } else {
    var _mo = new MutationObserver(function () {
      if (!_html.classList.contains('cms-loading')) {
        _mo.disconnect();
        requestAnimationFrame(flushPending);
      }
    });
    _mo.observe(_html, { attributes: true, attributeFilter: ['class'] });
  }
  setTimeout(flushPending, 1600);

  return function (container) {
    var els = container
      ? Array.from(container.querySelectorAll('.reveal:not(.visible)'))
      : Array.from(document.querySelectorAll('.reveal:not(.visible)'));
    observe(els);
  };
})();

// ── AUTO-REVEAL: tag content elements, reveal on scroll (scroll-based, iframe-safe) ──
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function tag() {
    var singleSelectors = [
      '.alt-section',
      '.faq-item',
      '.job-card',
      '.cta',
      '.cta > *',
      '.contact-section',
      '.about-banner .about-content',
      '.projekt-hero-content',
      '.projekt-text',
      '.projekt-sidebar',
      '.projekt-gallery',
      '.projekt-nav',
      '.page-body-section',
      '.job-detail > *:not(.back-link)',
      '.about-intro > *',
      '.contact-intro > *',
      '.quality-intro > *',
      '.jobs-header > *',
      '.gallery-header > *',
      '.grail-header > *',
      '.keywords-section .kw-icon-item',
      '.rich-text-section',
      '.chap',
      '.chap-eyebrow',
      '.chap-heading',
      '.chap-body',
      '.chap-imgs',
      '.chap-text',
      '.chap-figure',
      '.chap-quote',
      '.about-meta',
      '.about-heading',
      '.about-intro-lead',
      '.about-intro-body',
      '.about-divider',
      '.contact-intro-meta',
      '.contact-intro-heading',
      '.contact-intro-lead',
      '.contact-intro-body',
      '.contact-intro-divider-line',
      '.form-grid',
      '.form-consent',
      '.contact-section button[type="submit"]',
      '.radio-group'
    ];
    document.querySelectorAll(singleSelectors.join(', ')).forEach(function (el) {
      el.classList.add('reveal');
    });

    var grids = [
      { selector: '.cards', children: '.card' },
      { selector: '.icon-cards', children: '.icon-card' },
      { selector: '.project-grid', children: '.project-card' },
      { selector: '.pg-grid', children: '.pg-item' },
      { selector: '.projects-grid', children: '.proj-card' },
      { selector: '.gallery-rows .gallery-row', children: '.gallery-item' },
      { selector: '.grail-grid', children: '.grail-tile' },
      { selector: '.job-list', children: '.job-card' },
      { selector: '.kw-icons-row', children: '.kw-icon-item' }
    ];
    grids.forEach(function (g) {
      document.querySelectorAll(g.selector).forEach(function (grid) {
        Array.from(grid.querySelectorAll(g.children)).forEach(function (child, i) {
          child.classList.add('reveal');
          var d = Math.min(i + 1, 5);
          if (d > 0) child.classList.add('reveal-d' + d);
        });
      });
    });
  }

  var ticking = false;
  function check() {
    var vp = window.innerHeight;
    var triggerAt = vp * 0.92;
    document.querySelectorAll('.reveal:not(.visible)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < triggerAt && rect.bottom > 0) {
        el.classList.add('visible');
      }
    });
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      check();
      ticking = false;
    });
  }

  function init() {
    tag();
    check();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setTimeout(check, 200);
    setTimeout(check, 800);
    setTimeout(check, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// ── FAQ ACCORDION ──
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-q');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    if (!item) return;
    var list = item.closest('.faq-list') || item.parentElement;
    var isOpen = item.classList.contains('open');
    if (list) {
      list.querySelectorAll('.faq-item.open').forEach(function (el) {
        el.classList.remove('open');
        var q = el.querySelector('.faq-q');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
    }
    if (!isOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
})();

// ── MOBILE NAV HAMBURGER ──
(function () {
  var nav = document.querySelector('nav');
  if (!nav) return;
  var navLinks = nav.querySelector('.nav-links');
  if (!navLinks) return;

  var btn = document.createElement('button');
  btn.className = 'nav-hamburger';
  btn.setAttribute('aria-label', 'Menü öffnen');
  btn.innerHTML = '<span></span><span></span><span></span>';
  nav.appendChild(btn);

  function closeMenu() {
    navLinks.classList.remove('mobile-open');
    btn.classList.remove('open');
    document.body.style.overflow = '';
    btn.setAttribute('aria-label', 'Menü öffnen');
  }

  btn.addEventListener('click', function () {
    var isOpen = navLinks.classList.toggle('mobile-open');
    btn.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
    btn.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
  });

  navLinks.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 760) closeMenu();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) closeMenu();
  });
})();

// ── AUTO TWO-COLUMN LEAD TEXT ──
(function () {
  var lead = document.querySelector('.page-lead');
  if (lead && lead.textContent.length > 600) {
    lead.classList.add('lead-two-col');
  }
  if (lead) {
    new MutationObserver(function () {
      if (lead.textContent.length > 600) {
        lead.classList.add('lead-two-col');
      } else {
        lead.classList.remove('lead-two-col');
      }
    }).observe(lead, { childList: true, characterData: true, subtree: true });
  }
})();

// ── DECORATIVE WAVE ──
(function () {
  var wave = document.createElement('div');
  wave.className = 'site-wave';
  wave.setAttribute('aria-hidden', 'true');
  wave.innerHTML = '<svg viewBox="0 0 100 400" preserveAspectRatio="none">'
    + '<path pathLength="1" d="M5,0 C5,55 90,85 90,125 C96,165 74,198 90,238 '
    + 'C104,272 74,308 90,342 C104,370 80,390 90,400"/>'
    + '</svg>';
  document.body.insertBefore(wave, document.body.firstChild);
})();

// ── LIGHTBOX — Bilder per Klick vergrößern ──
(function () {
  var triggers = document.querySelectorAll('.pg-item img');
  if (!triggers.length) return;

  // Lightbox-Markup anlegen (einmal pro Seite)
  var lightbox = document.createElement('div');
  lightbox.className = 'lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.innerHTML =
    '<button class="lightbox-close" aria-label="Schließen">×</button>' +
    '<button class="lightbox-prev" aria-label="Vorheriges Bild">←</button>' +
    '<button class="lightbox-next" aria-label="Nächstes Bild">→</button>' +
    '<img class="lightbox-img" src="" alt="">' +
    '<div class="lightbox-counter"></div>';
  document.body.appendChild(lightbox);

  var img = lightbox.querySelector('.lightbox-img');
  var counter = lightbox.querySelector('.lightbox-counter');
  var btnClose = lightbox.querySelector('.lightbox-close');
  var btnPrev = lightbox.querySelector('.lightbox-prev');
  var btnNext = lightbox.querySelector('.lightbox-next');

  var images = Array.prototype.slice.call(triggers);
  var current = 0;

  function getFullSrc(thumb) {
    // Shopify-CDN: width-Param hochstellen, falls vorhanden
    var src = thumb.currentSrc || thumb.src;
    return src.replace(/(\?|&)width=\d+/, '$1width=2400');
  }

  function show(index) {
    if (index < 0) index = images.length - 1;
    if (index >= images.length) index = 0;
    current = index;
    img.src = getFullSrc(images[current]);
    img.alt = images[current].alt || '';
    counter.textContent = (current + 1) + ' / ' + images.length;
  }

  function open(index) {
    show(index);
    lightbox.classList.add('is-open');
    document.body.classList.add('lightbox-active');
  }

  function close() {
    lightbox.classList.remove('is-open');
    document.body.classList.remove('lightbox-active');
  }

  // Klick auf Bilder öffnet Lightbox
  images.forEach(function (thumb, i) {
    thumb.addEventListener('click', function (e) {
      e.preventDefault();
      open(i);
    });
  });

  // Schließen
  btnClose.addEventListener('click', close);
  img.addEventListener('click', close);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) close();
  });

  // Navigation
  btnPrev.addEventListener('click', function (e) {
    e.stopPropagation();
    show(current - 1);
  });
  btnNext.addEventListener('click', function (e) {
    e.stopPropagation();
    show(current + 1);
  });

  // Keyboard
  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });

  // Touch-Swipe
  var touchStartX = 0;
  lightbox.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  lightbox.addEventListener('touchend', function (e) {
    var diff = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) show(current - 1);
      else show(current + 1);
    }
  });
})();